import * as React from 'react'
import LocalizationStore from '../Stores/LocalizationStore'

export function exportToCsvList(filename: string, data: Array<Object>) {
    
    let result: Array<any> = []

    let fieldRow = new Array()
    Object.keys(data[0]).forEach(k => {
        fieldRow.push(LocalizationStore.getInstance().t(k))
    })
    result[0] = fieldRow

    data.forEach((d, i) => {
        let row = new Array()
        let keys = Object.keys(d)

        keys.forEach(k => {
            if (!React.isValidElement(d[k])) {
                row.push(d[k])
            } else {
                row.push(d[k].props.children)
            }
        })

        result[i + 1] = row
    })

    exportToCsv(filename, result)
}

export function exportToCsv(filename: string, rows: Array<any>) {
    var processRow = function (row: any) {
        var finalVal = ''
        for (var j = 0; j < row.length; j++) {
            var innerValue = row[j] === null ? '' : row[j].toString()
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString()
            }
            var result = innerValue.replace(/"/g, '""')
            if (result.search(/("|,|\n)/g) >= 0) {
                result = '"' + result + '"'
            }
            if (j > 0) {
                finalVal += ','
            }

            finalVal += result
        }
        return finalVal + '\n'
    }

    var csvFile = ''
    for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i])
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' })
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename)
    } else {
        var link = document.createElement('a')
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob)
            link.setAttribute('href', url)
            link.setAttribute('download', filename)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Helpers/ExportCsvHelper.ts